import { IconButton, Shadow, Text, HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';

import {
  TableContentItemBadge,
  TableContentItemCaptions,
} from '../../../../../../components/TableContent';
import { messageError } from '../../../../../../store/batchTicket/constants';
import { ItemTag } from '../../../Customer/components/ItemTag';

import { getOffersQuantityText } from './constants';

import { TotalSummaryResponsiveItem } from '.';

export const TotalSummaryItemMobile: React.FC<TotalSummaryResponsiveItem> = ({
  handleRemoveCustomer,
  handleDetailsCustomer,
  handleExportItem,
  item,
  detailsBasketItemButtonIsDisabled,
  availableBalance,
  allocatedBalanceField,
  remainingBalanceField,
}) => {
  return (
    <Shadow borderRadius={BoxRadius.xs} level={2}>
      <VStack space={Spacing['inline.xxxs']} p={Spacing['inline.xxs']} borderRadius={BoxRadius.xs}>
        <HStack alignItems="center" justifyContent="space-between">
          <VStack>
            <Text
              noOfLines={1}
              variant="semibold"
              fontSize={Typography['fontsize.md']}
              color="neutral.darkest">
              {item?.customer?.customerName || messageError}
            </Text>
            <HStack space={Spacing['inline.nano']} alignItems="center">
              <Text fontSize={Typography['fontsize.xs']} color="neutral.dark">
                Conta
              </Text>
              <Text fontSize={Typography['fontsize.xs']} color="neutral.dark">
                {item?.customer?.account?.accountNumber || messageError}
              </Text>
              <TableContentItemCaptions forceDesktop icons={['ProfessionalInvestor']} />
            </HStack>
          </VStack>
          <HStack alignItems={'center'} space={Spacing['inline.xxxs']}>
            <TableContentItemBadge>
              {item?.customer?.suitabilityProfileName || 'conservador'}
            </TableContentItemBadge>
            {handleRemoveCustomer && (
              <IconButton
                testId="remove-icon-button"
                borderRadius={BoxRadius.sm}
                icon="Trash"
                onPress={handleRemoveCustomer}
                p={0}
                iconColor={Color['feedback.error.default']}
                iconSize="sm"
              />
            )}
            {handleExportItem && (
              <IconButton
                testId="export-icon-button"
                borderRadius={BoxRadius.sm}
                icon="Pdf"
                onPress={handleExportItem}
                p={0}
                iconColor={Color['brand.tertiary.principal']}
                iconSize="sm"
              />
            )}
          </HStack>
        </HStack>
        <VStack space={Spacing['inset.nano']}>
          <HStack alignItems={'center'} justifyContent={'space-between'}>
            <Text fontSize={Typography['fontsize.md']} color="neutral.black">
              Hashtag
            </Text>
            <ItemTag
              isListing
              data={(item?.customer?.hashtags as never) || []}
              itemId={item?.customer?.account?.accountNumber}
            />
          </HStack>
          <HStack alignItems={'center'} justifyContent={'space-between'}>
            <Text fontSize={Typography['fontsize.md']} color="neutral.black">
              Ativos adicion.
            </Text>
            <Text noOfLines={1} fontSize={Typography['fontsize.md']} color="neutral.black">
              {getOffersQuantityText(item?.totalCustomerOffers)}
            </Text>
          </HStack>
          <HStack alignItems={'center'} justifyContent={'space-between'}>
            <Text fontSize={Typography['fontsize.md']} color="neutral.black">
              Saldo disponível
            </Text>
            <Text noOfLines={1} fontSize={Typography['fontsize.md']} color="neutral.black">
              {Utils.Mask.Money(availableBalance)}
            </Text>
          </HStack>
          <HStack alignItems={'center'} justifyContent={'space-between'}>
            <Text fontSize={Typography['fontsize.md']} color="neutral.darkest" variant="semibold">
              Saldo alocado | %
            </Text>
            <Text fontSize={Typography['fontsize.md']} color="neutral.darkest">
              {allocatedBalanceField}
            </Text>
          </HStack>
          <HStack alignItems={'center'} justifyContent={'space-between'}>
            <Text fontSize={Typography['fontsize.md']} color="neutral.darkest" variant="semibold">
              Saldo restante | %
            </Text>
            <Text fontSize={Typography['fontsize.md']} color="neutral.darkest">
              {remainingBalanceField}
            </Text>
          </HStack>
        </VStack>
        {handleDetailsCustomer && (
          <IconButton
            isDisabled={detailsBasketItemButtonIsDisabled}
            alignSelf={'flex-end'}
            testId="details-icon-button"
            borderRadius={BoxRadius.sm}
            icon="ArrowRight"
            onPress={handleDetailsCustomer}
            p={0}
            iconColor={Color['brand.tertiary.principal']}
            iconSize="xs"
          />
        )}
      </VStack>
    </Shadow>
  );
};
